import { payOptions, payStaus } from 'json/new-to-old-audit'
export let filterLabels = [
  {
    label: '支付方式',
    type: 'select',
    value: 'channel',
    clearable: true,
    options: payOptions
  },
  {
    label: '更新时间',
    type: 'time-slot',
    value: 'modifiedDate',
    clearable: true,
    startName: 'modifiedDateStart', // 返回数据时，开始时间的字段名
    endName: 'modifiedDateEnd' // 返回数据时，结束时间的字段名
  },
  {
    label: '支付状态',
    type: 'select',
    value: 'status',
    clearable: true,
    options: payStaus
  },
  {
    label: '分/子公司',
    type: 'select',
    value: 'subMerchantOrganizationId',
    clearable: true,
    filterable: true,
    options: []
  }
]
export let tableLabels = [
  {
    label: '生命银行流水号',
    value: 'externalOrderId'
  },
  {
    label: '支付方式',
    value: 'channel'
  },
  {
    label: '支付状态',
    value: 'status'
  },
  {
    label: '支付金额',
    value: 'amount'
  },
  {
    label: '分/子公司',
    value: 'subMerchantOrganizationName'
  },
  {
    label: '微信/支付宝的流水号',
    value: 'thirdPartyOrderId'
  },
  {
    label: '来源业务ID',
    value: 'sourceServiceObjectIds'
  },
  {
    label: '来源业务',
    value: 'sourceServiceTag'
  },
  {
    label: '支付发起时间',
    value: 'pay_starting_time'
  },
  {
    label: '最后的更新时间',
    value: 'last_modified_date'
  }
]
